<style>

.bg{
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-image: url("/i/signup-bg-wizard.jpg");
  background-size: cover;
  color: black;
  padding: 20px;
  overflow-y: scroll;
}

.margin{
  color: white;
  margin-top: 50px;
  text-align: center;
}

.slider{
  padding: 0 20px;
}
</style>

<div class="bg">
  <div class="title-signup">What proximity would you like for finding <u>events</u>?</div>
  
  <div class="margin slider">
    <RangeSlider id="distanceEvents" min="{2}" max="{80}" float bind:values="{distanceEvents}" springValues="{ { stiffness: 0.25, damping: 0.9 } }"></RangeSlider>
  </div>
  
  <div class="margin">Within {distanceEvents[0]} miles</div>
  
  
  <div class="title-signup">What proximity would you like for finding <u>friends</u>?</div>
  
  <div class="margin slider">
    <RangeSlider id="distanceFriends" min="{2}" max="{80}" float bind:values="{distanceFriends}" springValues="{ { stiffness: 0.25, damping: 0.9 } }"></RangeSlider>
  </div>
  
  <div class="margin">Within {distanceFriends[0]} miles</div>
  
  <div class="has-buttons"></div>
</div>

<!-- <div class="next">
  <button on:click="{next}" disabled="{nextDisabled}">Next</button>
</div> -->
<NextButton on:click="{next}" disabled="{nextDisabled}"></NextButton>

<script>

import {push, pop, replace, location, link} from 'svelte-spa-router';

import RangeSlider from "svelte-range-slider-pips";
import NextButton from "../../../../components/NextButton.svelte";

import Signup from "../../../../helpers/Signup.js";
import Validate from "../../../../helpers/Validate.js";

import { onMount } from "svelte";
onMount(async () => {
  try {
    Signup.verifyPersonalObject();
  } catch (e) {
    console.log("error:", e);
    
    if (e == "Must start from beginning") {
      document.location = "/";
    }
    
    return;
  }
  
  // if signup is already complete, then we push the user outta here...
  let signupComplete = Signup.getPersonalObject("signupComplete");
  if (signupComplete == true) {
    document.location = "/";
    return;
  }
  
  allowSignup = true;

  distanceSaved = Signup.getPersonalObject("distanceSaved");
  
  // Signup.saveToPersonalObject("distanceEvents", "");
  let tde = Signup.getPersonalObject("distanceEvents");
  distanceEvents = [ tde == 0 ? 10 : tde ];
  
  // Signup.saveToPersonalObject("distanceFriends", "");
  let tdf = Signup.getPersonalObject("distanceFriends");
  distanceFriends = [ tdf == 0 ? 2 : tdf ];
  
  if (distanceSaved == true) {
    nextDisabled = false;
  } else {
    check();
  }
  
});

let allowSignup = false;
let distanceEvents = [10];
let distanceFriends = [2];
let distanceSaved = false;
let nextDisabled = true;


function check() {
  distanceSaved = false;
  try {
    Validate.allowSignup(allowSignup);
    nextDisabled = false;
  } catch (e) {
    nextDisabled = true;
    console.log("error:", e);
  }
}


async function next() {
  if (distanceSaved == false) {
    await Signup.saveToPersonalObject("distanceEvents", distanceEvents[0]);
    await Signup.saveMe("distanceEvents");
    
    await Signup.saveToPersonalObject("distanceFriends", distanceFriends[0]);
    await Signup.saveMe("distanceFriends");
    
    await Signup.saveToPersonalObject("distanceSaved", true);
  }
  
  push("/signup/profile/personal/photos");
}


</script>